import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "19",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.712 7.782 17.413 0h-1.588l-5.818 6.757L5.36 0H0l7.027 10.218L0 18.38h1.588l6.144-7.136 4.908 7.136H18zm-2.175 2.526-.712-1.017L2.16 1.194H4.6L9.17 7.728l.712 1.018 5.943 8.493h-2.439z"
    }, null, -1)
  ])))
}
export default { render: render }